module.exports = __webpack_public_path__ + "assets/img/icon4.8b971c3a.svg";